import styled, { css } from "styled-components";
import SportIcons from "images/sports/common/sp_layout.png";

export const Container = styled.div`
  width: calc(100% - 60px);
  padding: 0px 30px 30px 30px;
  background: #fff;
`;

export const Wrapper = styled.ul`
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: repeating-linear-gradient(
    #277531 0,
    #277531 50px,
    #287933 50px,
    #287933 100px
  );
  position: relative;

  &:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 30px;
    transform: translate(-50% -50%);
    height: calc(100% - 60px);
    background: #1c5323;
    width: 2px;
  }
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  width: 100%;

  &:not(:first-child) {
    ${(props) =>
      props.isNotice === "TOTAL"
        ? css`
            margin-top: 30px;
          `
        : css`
            margin-top: 25px;
          `}
  }
`;

export const EventText = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;
  line-height: 20px;

  ${(props) =>
    props.locationType === "AWAY"
      ? css`
          order: 3;
          text-align: left;
        `
      : css`
          order: 1;
          text-align: right;
        `}
  & > strong {
    font-weight: bold;
    color: #a2ffae;
    margin-right: 3px;
  }
  flex: 1;
`;

export const EventTime = styled.div`
  color: #fff;
  flex: 1;
  ${(props) =>
    props.locationType === "AWAY"
      ? css`
          order: 1;
          text-align: right;
        `
      : css`
          order: 3;
          text-align: left;
        `}
`;

export const EventType = styled.em`
  order: 2;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 13px;
  ${(props) =>
    props.isNotice
      ? css`
          max-width: 100px;
          min-width: 100px;
          height: 35px;
          color: #fff;
          border-radius: 17px;
          background: #1c5323;
        `
      : css`
          background: #fff;
          height: 50px;
          max-width: 50px;
          min-width: 50px;
          border-radius: 100%;
          text-indent: -9999px;
          &:after {
            width: 16px;
            height: 16px;
            background: url(${SportIcons}) no-repeat 0 -9999px;
            background-size: 350px 350px;
          }
        `}

  ${(props) =>
    props.eventType === "GOAL" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -125px -240px;
      }
    `};
  ${(props) =>
    props.eventType === "OWN_GOAL" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -145px -240px;
      }
    `};
  ${(props) =>
    props.eventType === "NO_GOAL" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -165px -240px;
      }
    `};
  ${(props) =>
    props.eventType === "PK_SUCCESS" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -185px -240px;
      }
    `};
  ${(props) =>
    props.eventType === "PK_FAIL" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -205px -240px;
      }
    `};
  ${(props) =>
    props.eventType === "YELLOW_CARD" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -225px -240px;
      }
    `};
  ${(props) =>
    props.eventType === "RED_CARD" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -245px -240px;
      }
    `};
  ${(props) =>
    props.eventType === "SUBSTITUTE" &&
    css`
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        background-position: -265px -240px;
      }
    `};
`;
